import { api } from "@/lib/api";

export async function uploadToCloudinary(file, type, onProgress) {
  const { data: sig } = await api.get("/media/signature", { params: { resource_type: type === "photo" ? "image" : "video" } });
  const form = new FormData();
  form.append("file", file);
  form.append("api_key", sig.api_key);
  form.append("timestamp", sig.timestamp);
  form.append("signature", sig.signature);
  form.append("folder", sig.folder);
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("POST", `https://api.cloudinary.com/v1_1/${sig.cloud_name}/${sig.resource_type}/upload`);
    xhr.upload.onprogress = (e) => e.lengthComputable && onProgress?.(Math.round((e.loaded / e.total) * 100));
    xhr.onload = () => {
      let body = {};
      try { body = JSON.parse(xhr.responseText); } catch {}
      if (xhr.status < 300) resolve({ public_id: body.public_id, resource_type: sig.resource_type });
      else reject(new Error(body?.error?.message || "Falha no envio para a nuvem"));
    };
    xhr.onerror = () => reject(new Error("Falha de rede no envio para a nuvem"));
    xhr.send(form);
  });
}

export async function uploadDocument(file, onProgress) {
  const { data: sig } = await api.get("/media/doc-signature");
  const form = new FormData();
  form.append("file", file);
  form.append("api_key", sig.api_key);
  form.append("timestamp", sig.timestamp);
  form.append("signature", sig.signature);
  form.append("folder", sig.folder);
  form.append("type", sig.type);
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("POST", `https://api.cloudinary.com/v1_1/${sig.cloud_name}/image/upload`);
    xhr.upload.onprogress = (e) => e.lengthComputable && onProgress?.(Math.round((e.loaded / e.total) * 100));
    xhr.onload = () => {
      let body = {};
      try { body = JSON.parse(xhr.responseText); } catch {}
      if (xhr.status < 300) resolve({ public_id: body.public_id, format: body.format, pages: body.pages });
      else reject(new Error(body?.error?.message || "Falha no envio do documento"));
    };
    xhr.onerror = () => reject(new Error("Falha de rede no envio do documento"));
    xhr.send(form);
  });
}

export async function clipToFile(clip) {
  if (clip.file) return clip.file;
  const blob = await (await fetch(clip.previewUrl)).blob();
  return new File([blob], clip.type === "photo" ? "foto.jpg" : "video.mp4", { type: blob.type });
}
